import type {ReactNode} from 'react';
import type {CanvasChatMessage,CanvasImage,ChatImageSlot} from './canvas-types';
import {chatImageGroups} from './chat-image-groups';
import {recoveredRunImageSlots} from './canvas-run-recovery';

/** Chat shows completed thumbnails only; generation placeholders belong to Canvas. */
export function ChatImageGallery({message,images,renderSlot}:{message:CanvasChatMessage;images:readonly CanvasImage[];renderSlot:(slot:ChatImageSlot)=>ReactNode}){
 const runId=message.playbookProgress?.workflowRunId;
 const own=runId?images.filter(image=>image.workflowRunId===runId&&!!image.src):[];
 // Old thumbnail-only messages have no attempt/slot identity. Once the owned
 // Canvas collection is available it is the delivery record for this run.
 const source=!message.imageSlots?.length&&runId?{...message,imageSlots:own.length?[]:(message.thumbnails??[]).map((resolved,index)=>({index,resolved,workflowRunId:runId}))}:message;
 const slots=(runId?recoveredRunImageSlots(source,runId,images):source.imageSlots??[]).filter(slot=>!slot.failed&&!!slot.resolved);
 if(!slots.length)return null;
 return <div className="flex flex-nowrap gap-2 mt-2 items-start overflow-x-auto pb-1" data-testid={`chat-image-gallery-${message.id}`}>
  {chatImageGroups(slots,images).map(group=><div key={group.key} data-concept-group={group.key} className="flex shrink-0 gap-2 items-start">
   {group.slots.map(slot=><div key={slot.index} className="contents">{renderSlot(slot)}</div>)}
  </div>)}
 </div>;
}
